// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueImg from 'v-img'
import VueLazyload from 'vue-lazyload'
import moment from 'moment'
import { sync } from 'vuex-router-sync'
import VueSwal from './utilities/vue-sweetalert2'
import store from './vuex/store'
import router from './router'
import Vue2Filters from 'vue2-filters'
import VueAnalytics from 'vue-analytics'
import Meta from 'vue-meta'
import VueScrollTo from 'vue-scrollto'
import VueCountdown from '@xkeshi/vue-countdown'
// import lodash from 'lodash'

window._ = require('lodash')
Vue.config.productionTip = false
Vue.use(VueScrollTo)

Vue.component('countdown', VueCountdown)

// You can also pass in the default options
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  cancelable: true,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})
Vue.use(Meta)
Vue.use(VueImg)
Vue.use(VueSwal)
Vue.use(Vue2Filters)
Vue.use(VueAnalytics, {
  id: 'UA-43561384-4',
  router,
  autoTracking: {
    pageviewOnLoad: false,
    exception: true,
    pageviewTemplate (route) {
      return {
        page: route.path,
        title: document.title,
        location: window.location.href
      }
    }
  }
})

Vue.use(VueLazyload, {
  preload: 1.2,
  attempt: 1,
  adapter: {
    loaded ({ bindType, el, naturalHeight, naturalWidth, $parent, src, loading, error, Init }) {
      // do something here
      // example for call LoadedHandler
      // LoadedHandler(el)
    },
    loading (listender, Init) {
      // console.log('loading')
    },
    error (listender, Init) {
      // console.log('error')
    }
  }
})

Vue.filter(['moment'], function (data, dateFormat) {
  let myDate = moment.unix(data)
  if (dateFormat === undefined) {
    return moment(myDate).locale('zh-tw').format('M/D')
  } else {
    return moment(myDate).locale('zh-tw').format(dateFormat)
  }
})

// Vue.filter(['moment'], function (data) {
//   let myDate = moment.unix(data)
//   return moment(myDate).locale('zh-tw').format('M/DD')
// })

Vue.filter(['moment-news'], function (data) {
  let myDate = moment(data)
  return moment(myDate).locale('zh-tw').format('YYYY/MM/DD')
})

router.beforeEach((to, from, next) => {
  // console.log('to: ', to, '\n' + 'from: ', from)
  if (to.matched.some(record => {
    // console.log(record.name + ': {', 'requiredAuth: ', record.meta.requiredAuth, '}')
    return record.meta.requiredAuth
  })) {
    // console.log('store: from => ', store.state.route.name)
    next(false)
    if (!store.state.auth.user.token.access_token && !window.localStorage.getItem('accessToken')) {
      const oauthWindow = window.open('https://oauth.4gamers.com.tw/oauth/authorize?client_id=' + process.env.OAUTH.clientId + '&response_type=code&redirect_uri=' + process.env.OAUTH.redirectUri + '&scope=member.profile.read member.hardware.read member.hardware.write member.notification.read member.notification.write member.games.read member.games.write', 'LoginModal', 'width=600,height=800,scrollbars=no', '_blank')
      let timer = setInterval(function () {
        if (oauthWindow.closed) {
          clearInterval(timer)
          // console.log('oauthWindow:', Vue)
          if (window.localStorage.getItem('accessToken')) {
            next()
          } else {
            next(false)
          }
        }
      }, 500)
      oauthWindow
    } else {
      next()
    }
  } else {
    next()
  }

  // console.log(from.path)
  // console.log(to.path)
  // console.log(router.app)
  // console.log(store.state.auth)
  // let accessToken = window.localStorage.getItem('accessToken')
  // if (accessToken) {
  //   console.log(accessToken)
  // } else if (!accessToken) {
  //   console.log('no')
  // }
})

router.afterEach((transition) => {
  // console.log(transition.path)
})

sync(store, router)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store: store,
  router: router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js